// extracted by mini-css-extract-plugin
export default {"root":"StickyHeader_root__Shy6V","inner":"StickyHeader_inner__wMsjJ","brand":"StickyHeader_brand__FekpR","cta":"StickyHeader_cta__kqE-1"};